const MaritalStatus = ['SINGLE', 'MARRIED', 'DIVORCED', 'WIDOWED']

export default MaritalStatus